import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';

/**
 * Hook personalizado para interceptar navegação e executar cleanup quando necessário
 * @param {Function} onNavigate - Função a ser executada antes da navegação
 * @param {boolean} isActive - Se o handler está ativo
 */
export const useNavigationHandler = (onNavigate, isActive = true) => {
  const history = useHistory();
  const originalPush = useRef(null);
  const originalReplace = useRef(null);
  const onNavigateRef = useRef(onNavigate);

  // Atualizar a referência da função quando ela mudar
  useEffect(() => {
    onNavigateRef.current = onNavigate;
  }, [onNavigate]);

  useEffect(() => {
    if (!isActive) return;

    // Salvar as funções originais se ainda não foram salvas
    if (!originalPush.current) {
      originalPush.current = history.push;
      originalReplace.current = history.replace;
    }

    // Interceptar history.push
    history.push = (...args) => {
      console.log('🔄 Navegação programática detectada (push):', args[0]);
      if (onNavigateRef.current) {
        onNavigateRef.current();
      }
      return originalPush.current.apply(history, args);
    };

    // Interceptar history.replace
    history.replace = (...args) => {
      console.log('🔄 Navegação programática detectada (replace):', args[0]);
      if (onNavigateRef.current) {
        onNavigateRef.current();
      }
      return originalReplace.current.apply(history, args);
    };

    // Cleanup: restaurar as funções originais
    return () => {
      if (originalPush.current) {
        history.push = originalPush.current;
      }
      if (originalReplace.current) {
        history.replace = originalReplace.current;
      }
    };
  }, [history, isActive]);

  return history;
};

export default useNavigationHandler;